if(!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class HeroCarousel extends HTMLElement {
      #sliderEl;
      #sliderInstance;
      
      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        const options = {
          speed: 2000,
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            prevEl: this.parentNode.querySelector('.slider-button.prev'),
            nextEl: this.parentNode.querySelector('.slider-button.next'),
          },
          pagination: {
            el: this.parentNode.querySelector('.slider-pagination'),
            type: "bullets",
            clickable: true
          }
        };

        this.#sliderInstance = new Swiper(this.#sliderEl, options);
      }
    }
  );
}